import ProductTile from "../ProductTile";
import CarouselProductHero from "../CarouselProductHero";
import styles from "./UpSellCarousel.css";

const renderProducts = ({ products, ...rest }) =>
  products.map((product, index) => (
    <ProductTile
      {...product}
      key={product.id}
      index={index}
      ProductHeroComponent={CarouselProductHero}
      className={styles.productTile}
      sellingFastStyle={styles.sellingFastBadge}
      {...rest}
    />
  ));

export default renderProducts;
